import textFit from 'textFit';

export default class Calendar {
  constructor() {

    $('#main.calendar-page').on('scroll', function(){
      $('.name').each(function(){
        if(this.getBoundingClientRect().top < window.innerHeight*0.98) {
          $(this).addClass('in');
        } else {
          $(this).removeClass('in');
        }
      });
    });

    setTimeout(function(){
      $('#main.calendar-page').trigger('scroll');
    }, 800);

    $(window).on('pageshow load', function(){
      $('#main.calendar-page').trigger('scroll');
    });

    if($('.listed').length<4) {
      $('.listed--element.ball').hide();
    }

    /*
    textFits();

    $(window).on('resize', textFits);

    function textFits(){
      $('.name').each(function(){
        var h = $(this).parent().outerHeight();
        var w = $(this).parent().outerWidth();

        $(this).css({
          'height' : parseInt(h),
          'width' : parseInt(w),
        });
        textFit(
          this,
          {
            multiLine: true,
            maxFontSize: 900,
          }
        );

        $(this).parents('.listed--names--name').css('min-height','0');
        $(this).css('height','auto');
      // $(this).textFit();
    });
  }
    */
  }
}
